import { format, formatDistance, formatRelative, subDays } from 'date-fns'
import { dateStringToDatePretty, dateMonthYearPretty, dateMonthYearSpanPretty, dateTimeRelative } from '../util/date'

export default {
    components: {},
    methods: {
        dateStringToDatePretty,
        dateMonthYearPretty,
        dateMonthYearSpanPretty,
        dateTimeRelative,
    },
}
